<div class="card">
  <form
    [formGroup]="loginForm"
    #login="ngForm">
    <div class="grid">
      <div class="col-5 flex align-items-center justify-content-center">
        <div class="p-fluid">
          <div class="field">
            <label for="username">Username</label>
            <input
              id="username"
              type="text"
              formControlName="email" />
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input
              id="password"
              type="password"
              formControlName="password" />
          </div>
          <p-button
            (onClick)="_login()"
            [disabled]="login.invalid"
            label="Login"></p-button>
        </div>
      </div>
    </div>
  </form>
</div>
